import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import SMSIcon from '@material-ui/icons/Sms';
import { IAlert } from '@types';
import store from '@lib/store';
import { Box } from '@atoms';

/**
 * Rendered as a COMPONENT, never called as a function — see the map below.
 */
const RenderAlert = ({ alert }: { alert: IAlert }) => {
  const [bail, setBail] = useState<boolean>(true);
  const { message } = alert;

  useEffect(() => {
    if (alert) {
      const timeout = setTimeout(() => setBail(false), 2000);
      return () => clearTimeout(timeout);
    }
  }, [alert]);

  if (bail || !alert) {
    return null;
  }

  return (
    <Box bgcolor="gray" borderRadius={4} color="white" p={2}>
      <Box fontSize="300%" mr={2}>
        <SMSIcon fontSize="inherit" />
      </Box>
      <Box column>
        <Box
          fontSize="150%"
          alignItems="center"
          width="300px"
          fontWeight="bold"
          mb={2}
        >
          (404) 341-6426
        </Box>
        <Box fontSize="125%">{message}</Box>
      </Box>
    </Box>
  );
};

export default observer(function Alerts() {
  return (
    <Box
      zIndex={1000}
      position="fixed"
      top="10px"
      left="0"
      right="0"
      fullWidth
      justifyContent="center"
    >
      {/*
        `store.alerts.map(RenderAlert)` CALLED RenderAlert as a plain function,
        so its useState and useEffect ran inside this component's render and
        appended two hooks per alert to *this* component's hook list.

        React requires the same hooks in the same order on every render, so the
        moment the alert count changed — precisely when an alarm fired or
        cleared — it threw "Rendered more hooks than during the previous
        render". That escapes to the top-level ErrorBoundary, which unmounts
        the whole dashboard.

        Rendering it as an element instead gives each alert its own component
        instance with its own hooks, so the count changing mounts and unmounts
        components rather than reshaping this one's hook list.
      */}
      {store.alerts.map(alert => (
        <RenderAlert key={alert.id} alert={alert} />
      ))}
    </Box>
  );
});
